import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { InstitutionProps } from '../../../models/arc-epi-props';
import { PlanSummary } from '../institution-model';
import { getCurrentPlan } from './plan-summary-helper';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../constants/routes';
import { PlanAdoptionFormTypes } from '../plan-adoption/models/plan-adoption-form-models';
import { DividerSection } from '../../../../../../stories/divider-section';
import { accordionOverrideStyles } from '../../../../../global/constants/theme/styles/components/generic-accordion';
import { AccordionHeader } from '../../../../../Global/components/layout/accordion-header';

interface Props {
    settings: InstitutionProps,
    planSummary: PlanSummary,
}

function AvailablePensionPlans(props: Props) {

    const { settings, planSummary } = props;
    const layDc = getCurrentPlan(planSummary?.dc);
    const layDb = getCurrentPlan(planSummary?.lay_db);
    const rsvp = getCurrentPlan(planSummary?.rsvp);
    const [expandAll, setExpandAll] = useState(false);
    const [expand2, setExpand2] = useState(false);
    const [expand3, setExpand3] = useState(false);
    const [expand4, setExpand4] = useState(false);
    const buttonClasses = buttonStyles();
    const dbPlanLink = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.DbPlanAdoption}`);
    const qccoPlanLink = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.QccoPlanAdoption}`);
    const accordionClasses = accordionOverrideStyles();


    const setExpandAction = () => {
        setExpandAll(!expandAll);
        setExpand2(!expandAll);
        setExpand3(!expandAll);
        setExpand4(!expandAll);
    };


    if (layDc && layDb && rsvp) {
        return null;
    }

    return (
        <DividerSection sectionText={settings?.planOfferingTitle} >
            <div className={`${accordionClasses.accordionContainer} border-bottom`}>
                <Accordion>
                    <AccordionSummary className='MuiAccordionSummary-root-parent' expandIcon={<ExpandMoreIcon />}>
                        <h3>{settings?.availablePlansSectionTitle}</h3>
                    </AccordionSummary>
                    <AccordionDetails >
                        <div className='MuiAccordionDetails-root-inner'>
                            <AccordionHeader>
                                <h4>{settings?.pensionPlansTitle}</h4>
                                <button onClick={setExpandAction} type='button' className={buttonClasses.linkButton}>{expandAll ? settings?.closeAllText : settings?.expandAllText}</button>
                            </AccordionHeader>

                            {
                                !layDb &&
                                <Accordion expanded={expand2} onChange={() => setExpand2(!expand2)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <p>{settings?.layDbSectionTitle}</p>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <div>
                                            <ContentSpacer>
                                                <WysiwygWithReactLink content={settings?.layDbSectionDescription} />
                                            </ContentSpacer>
                                            <Link className={buttonClasses.primaryButton} to={`${dbPlanLink}?formType=${PlanAdoptionFormTypes.LayDb}`} >{settings?.adoptPlanButtonText}</Link>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            }
                            {
                                !layDc &&
                                <Accordion expanded={expand3} onChange={() => setExpand3(!expand3)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <p>{settings?.layDcSectionTitle}</p>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <div>
                                            <ContentSpacer>
                                                <WysiwygWithReactLink content={settings?.layDcSectionDescription} />
                                            </ContentSpacer>
                                            <Link className={buttonClasses.primaryButton} to={`${qccoPlanLink}?formType=${PlanAdoptionFormTypes.LayDc}`} >{settings?.adoptPlanButtonText}</Link>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            }
                            {
                                !rsvp &&
                                <Accordion expanded={expand4} onChange={() => setExpand4(!expand4)}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <p>{settings?.rsvpSectionTitle}</p>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <div>
                                            <ContentSpacer>
                                                <WysiwygWithReactLink content={settings?.rsvpSectionDescription} />
                                            </ContentSpacer>
                                            <Link className={buttonClasses.primaryButton} to={`${qccoPlanLink}?formType=${PlanAdoptionFormTypes.Rsvp}`} >{settings?.adoptPlanButtonText}</Link>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            }
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </DividerSection>

    );
}

export default AvailablePensionPlans;